var __jsx = React.createElement;
import React from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { useTranslation } from "@i18n";
import { CDN_LINK } from '@globalConfig';
var ProcessStepsSection = function ProcessStepsSection() {
  var lang = useLang();
  var isArabic = lang === 'ar';
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var steps = [{
    number: "01",
    image: CDN_LINK + "/assets/images/sell-trade/step-2.png",
    title: tShort('process/step1_title', {
      ns: 'web_sell_trade'
    }),
    description: tShort('process/step1_description', {
      ns: 'web_sell_trade'
    })
  }, {
    number: "02",
    image: CDN_LINK + "/assets/images/sell-trade/step-1.png",
    title: tShort('process/step2_title', {
      ns: 'web_sell_trade'
    }),
    description: tShort('process/step2_description', {
      ns: 'web_sell_trade'
    })
  }, {
    number: "03",
    image: CDN_LINK + "/assets/images/sell-trade/step-0.png",
    title: tShort('process/step3_title', {
      ns: 'web_sell_trade'
    }),
    description: tShort('process/step3_description', {
      ns: 'web_sell_trade'
    })
  }, {
    number: "04",
    image: CDN_LINK + "/assets/images/sell-trade/step-3.png",
    title: tShort('process/step4_title', {
      ns: 'web_sell_trade'
    }),
    description: tShort('process/step4_description', {
      ns: 'web_sell_trade'
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "my-10 md:my-[71px] px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[28px] font-bold text-[#3c56d4] text-center mb-8 md:text-[40px] md:mb-8"
  }, tShort('process/title', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6 lg:justify-items-center"
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white rounded-3 text-center w-full mx-auto md:max-w-[273px] max-h-[271px]",
      key: index
    }, /*#__PURE__*/React.createElement("img", {
      src: step.image,
      alt: "Step ".concat(step.number),
      className: "w-full h-[175px] object-contain mb-5 bg-[#F1F6FC] rounded-lg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "mb-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[32px]  text-right rtl:text-right ltr:text-left font-extrabold text-[#CACACA] mb-3"
    }, step.number), /*#__PURE__*/React.createElement("h3", {
      className: "text-[18px] font-bold text-[#3c56d4] text-right rtl:text-right ltr:text-left md:text-[16px]"
    }, step.title)));
  }))));
};
export default ProcessStepsSection;